export class LoginInput {
    codigoUsuarioSesion: string;
    password: string;
}